import { AnalyticsData } from 'types'
import { getIsoStringYearMonthDay, getShopId, useApiQuery } from 'utils'

export const useAnalytics = (start: Date, end: Date) => {
    const shopId = getShopId()

    return useApiQuery<AnalyticsData>({
        query: `
            query getAnalytics(
                $shop: String!,
                $request: GetAnalyticsRequest!
            ) {
                getAnalytics(
                    shop: $shop,
                    request: $request
                ) {
                    data {
                        actual
                        name
                        value {
                            appointments
                            sales
                        }
                    }
                    topServices {
                        id
                        title
                        count
                        image {
                            id
                            path
                        }
                    }
                    currency
                    currencySymbol
                    totalSales
                }
            }
        `,
        variables: {
            shop: shopId,
            request: {
                start: getIsoStringYearMonthDay(start),
                end: getIsoStringYearMonthDay(end),
            },
        },
        cacheKey: ['analytics', shopId, start, end],
        onSuccess: response => response.data.getAnalytics,
    })

}
